export default "__VITE_ASSET__d18b3edb__"